import SelectorEngine from '../../utils/dom/selector-engine';
import BaseComponent from '../BaseComponent';
import EventHandler from '../../utils/dom/event-handler';

const NAME = 'Toggle';

class Toggle extends BaseComponent {
	constructor(element) {
		super(element);
		this.status = undefined;
		this.button = SelectorEngine.findOne('input', element);
		this.form = element.closest('form');
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	createEvent() {
		const formEvent = new CustomEvent('toggleStatus', {
			bubbles: true,
			detail: {
				status: this.status
			}
		});
		return formEvent;
	}

	init() {
		EventHandler.on(this.button, 'change', (event) => {
			this.status = event.target.checked;
			window.dispatchEvent(this.createEvent());
		});
	}
}

export default Toggle;
